module.exports = __webpack_public_path__ + "img/beckTestIcon.8f5274aa.svg";